import { useMutation } from 'react-query';
import BattlesService from 'services/battles/BattlesService';
import { BattlePlayerStatusOption } from '../../../../models/battles/BattlePlayerStatus';

export type UseUpdateMyBattlePlayerStatusProps = {
	'services.battlesService': BattlesService;
};

export const useUpdateMyBattlePlayerStatus = (props: UseUpdateMyBattlePlayerStatusProps) => {
	const battlesService = props['services.battlesService'];

	return useMutation({
		mutationKey: ['battles-update-my-battle-status'],
		mutationFn: (option: BattlePlayerStatusOption) => battlesService.updateMyStatus(option),
	});
};

export default useUpdateMyBattlePlayerStatus;
